import { app } from '../../../../app';
import { Controller } from './current-plan.controller';

app.component('currentPlan', {
    bindings:{
        licenseDetails: '<',
    },
    controller: Controller,
    templateUrl: require('./current-plan.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/current-plan.component.js